export default function validateCPF(cpf) {
  if (!cpf) return false
  const sanitized = cpf.replace(/\D/g, '')
  if (sanitized.length !== 11) return false
  if (/^(\d)\1+$/.test(sanitized)) return false
  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(sanitized.charAt(i)) * (10 - i)
  }
  let rev = 11 - (sum % 11)
  if (rev === 10 || rev === 11) rev = 0
  if (rev !== parseInt(sanitized.charAt(9))) return false
  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(sanitized.charAt(i)) * (11 - i)
  }
  rev = 11 - (sum % 11)
  if (rev === 10 || rev === 11) rev = 0
  if (rev !== parseInt(sanitized.charAt(10))) return false
  return true
}
